import { APIVehicle, Vehicle, VehicleType } from '../models/vehicle';
import { TimeTransform } from './time-transform';

export class VehicleTransform {
  static fromAPI(apiVehicle: APIVehicle): Vehicle {
    const odometerReadDateTime = TimeTransform.parse(
      apiVehicle.odometerReadDate
    );
    const manufacturingDateTime = TimeTransform.parse(
      apiVehicle.manufacturingDate
    );
    const startDateTime = TimeTransform.parse(apiVehicle.startDate);
    const terminationDateTime = TimeTransform.parse(apiVehicle.terminationDate);

    const vehicle: Vehicle = {
      ...apiVehicle,
      id: apiVehicle.id.value,
      businessAccountId: apiVehicle.businessAccountId.value,
      status:
        apiVehicle.status !== undefined
          ? apiVehicle.status.vehicleStatus
          : 'VEHICLE_STATUS_INCOMPLETE',
      vehicleType:
        apiVehicle.vehicleType !== undefined
          ? apiVehicle.vehicleType.vehicleType
          : VehicleType.Unknown,
      odometerReadDate: odometerReadDateTime.date,
      odometerReadTime: odometerReadDateTime.time,
      manufacturingDate: manufacturingDateTime.date,
      manufacturingTime: manufacturingDateTime.time,
      startDate: startDateTime.date,
      startTime: startDateTime.time,
      terminationDate: terminationDateTime.date,
      terminationTime: terminationDateTime.time
    };
    return vehicle;
  }

  // TODO this is super annoying right now
  // Do not trust this code.
  static toAPI(vehicle: Vehicle): APIVehicle {
    const apiVehicle: APIVehicle = {
      ...vehicle,
      id: null,
      businessAccountId: { value: vehicle.businessAccountId + '' },
      status: { vehicleStatus: vehicle.status + '' },
      vehicleType: {
        vehicleType: vehicle.vehicleType
      },
      odometerReadDate:
        vehicle.odometerReadDate !== '' && vehicle.odometerReadTime !== ''
          ? TimeTransform.join(
              vehicle.odometerReadDate + 'T00:00',
              vehicle.odometerReadTime
            )
          : null,
      manufacturingDate:
        vehicle.manufacturingDate !== '' && vehicle.manufacturingTime !== ''
          ? TimeTransform.join(
              vehicle.manufacturingDate + 'T00:00',
              vehicle.manufacturingTime
            )
          : null,
      startDate:
        vehicle.startDate !== '' && vehicle.startTime !== ''
          ? TimeTransform.join(vehicle.startDate + 'T00:00', vehicle.startTime)
          : null,
      terminationDate:
        vehicle.terminationDate !== '' && vehicle.terminationTime !== ''
          ? TimeTransform.join(
              vehicle.terminationDate + 'T00:00',
              vehicle.terminationTime
            )
          : null,
      labels: vehicle.labels
    };

    const nullableFields = [
      'fuelDrawCapacity',
      'registeredLadenGrossVehicleWeight',
      'unladenGrossVehicleWeight',
      'vehicleAxles',
      'horsepower',
      'odometer',
      'yearBuilt',
      'engineHours'
    ];

    nullableFields.forEach(
      field => (apiVehicle[field] = apiVehicle[field] || null)
    );

    return apiVehicle;
  }
}
